import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWeather = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.3333 23.3334C19.3333 25.5334 17.5333 27.3334 15.3333 27.3334C13.1333 27.3334 11.3333 25.5334 11.3333 23.3334H14C14 24.0667 14.6 24.6667 15.3333 24.6667C16.0667 24.6667 16.6667 24.0667 16.6667 23.3334C16.6667 22.6 16.0667 22 15.3333 22H2.66667V19.3334H15.3333C17.5333 19.3334 19.3333 21.1334 19.3333 23.3334ZM25.3333 9.33335C25.3333 6.76002 23.24 4.66669 20.6667 4.66669C18.0933 4.66669 16 6.76002 16 9.33335H18.6667C18.6667 8.22669 19.56 7.33335 20.6667 7.33335C21.7733 7.33335 22.6667 8.22669 22.6667 9.33335C22.6667 10.44 21.7733 11.3334 20.6667 11.3334H2.66667V14H20.6667C23.24 14 25.3333 11.9067 25.3333 9.33335ZM24.6667 15.3334H2.66667V18H24.6667C25.7733 18 26.6667 18.8934 26.6667 20C26.6667 21.1067 25.7733 22 24.6667 22V24.6667C27.24 24.6667 29.3333 22.5734 29.3333 20C29.3333 17.4267 27.24 15.3334 24.6667 15.3334Z",
		fill: "currentColor"
	})
});
export default SvgWeather;
